export default "__VITE_ASSET__CVMHujw8__"